import { Renewal } from "../Renewal";
import { useUpgradePlanContext } from "../UpgradePlanContext";

export const RenewalRoute = () => {
  const { source } = useUpgradePlanContext();

  return <Renewal source={source} />;
};
